import React, { useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'

export const CreateOperateElement = (props) => {
  const el = useRef(document.createElement('div'))
  useEffect(() => {
    const portal = document.getElementById('operate-element')
    if (portal) {
      portal.appendChild(el.current)

      return () => {
        portal.removeChild(el.current)
      }
    }
    return null
  }, [props.children])

  return ReactDOM.createPortal(props.children, el.current)
}

export const OperateContainer = () => <div id="operate-element" />
